import React from "react";
import { Box } from "@mui/material";
import ProductCard from "./ProductCard";

export default function ProductGrid({ products, onQuickView, isMobile = false }) {
  return (
    <Box
      sx={{
        display: "grid",
        gap: { xs: 1.5, sm: 2 },
        gridTemplateColumns: {
          xs: "repeat(auto-fill, minmax(160px, 1fr))", // mobile
          sm: "repeat(3, 1fr)",                        // force 3 columns between 600px–899px
          md: "repeat(auto-fill, minmax(280px, 1fr))"  // back to flexible layout from 900px+
        },
        alignItems: "stretch"
      }}
    >
      {products.map((p) => (
        <ProductCard
          key={p.id}
          product={p}
          onQuickView={onQuickView}
          isMobile={isMobile}
        />
      ))}
    </Box>
  );
}
